import type { NextPage } from 'next';
import React from 'react';
import { NotFound } from '~/components/AppLayout/NotFound';

const FourOhFour: NextPage = () => {
  return <NotFound />;
};

export default FourOhFour;
